<ng-content></ng-content>
@if (help()) {
<span class="av-tooltip-point">?</span>
} @if (enabled()) {
<span
  #tooltip
  role="tooltip"
  class="av-tooltip av-tooltip-{{ position() }} av-tooltip-align-{{ align() }}"
  [class.av-tooltip-wrap]="wrap()"
  [class.av-tooltip-detached]="detached()"
  [attr.popover]="detached() ? 'manual' : null"
  translate
>
  <ng-content select="[tooltipMessage]"></ng-content>
  <!--
    The message goes through the pipe inside its own element on purpose.
    ngx-translate's `translate` directive above remembers the first text it
    translated (`node.lookupKey`) and writes that same text back over every
    later interpolation, so a `[message]` that changes while the tooltip is
    alive would stay pinned to its first value. An element child is not a
    text node, so the directive leaves it alone — while projected text still
    gets the directive's translation, as it always has.
  -->
  <span class="av-tooltip-message">{{ message() | translate }}</span>
</span>
}
